// extracted by mini-css-extract-plugin
module.exports = {"checkboxInput":"checkboxGroup_checkboxInput__2FvA2","checkboxColumns":"checkboxGroup_checkboxColumns__1wbEa"};